import api from '@/api'

export default {
  createWeekPlan (me) {
    var plan = {}

    // Build the plan for the list of selected programs
    me.athlete.trainingPrograms.forEach((name, index) => {
      var program = new GenericProgram(me, api.getProgram(name))
      plan[program.id()] = program.build(index)
    })
    return plan
  }
}

class ProgramSession {
  constructor (id, name) {
    this.id = id
    this.index = undefined
    this.shortCode = undefined
    this.intensity = undefined
    this.name = name
    this.type = undefined
    this.restBefore = false
    this.tasks = []
  }
}

class GenericProgram {
  constructor (me, program) {
    this.me = me
    this.code = program.code
    this.name = program.name
    this.intensity = program.intensity
    this.type = program.type
    this.templateSessions = program.sessions
  }
  id () {
    return this.code + '-' + this.me.athlete.progSeqNum + '-' + this.me.id()
  }
  build (index) {
    var session = new ProgramSession(this.id(), this.name)
    session.index = index
    session.shortCode = this.code
    session.intensity = this.intensity
    session.type = this.type
    const i = this.me.athlete.progSeqNum % Object.keys(this.templateSessions).length
    const templateSession = this.templateSessions['W' + i]
    if (templateSession) {
      session = Object.assign(session, templateSession)
    }
    return session
  }
}



// WEBPACK FOOTER //
// ./src/api/coach.js